import { render } from "./LandingSearch.vue?vue&type=template&id=18e0956e&scoped=true&ts=true"
import script from "./LandingSearch.vue?vue&type=script&lang=ts"
export * from "./LandingSearch.vue?vue&type=script&lang=ts"

import "./LandingSearch.vue?vue&type=style&index=0&id=18e0956e&scoped=true&lang=css"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e0956e"]])

export default __exports__